import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ClientsAdd = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [redirect_url, setRedirectUrl] = useState("");
  const [email, setEmail] = useState("");

  const [nameErr, setNameErr] = useState("");
  const [domainErr, setDomainErr] = useState("");
  const [redirect_urlErr, setRedirectUrlErr] = useState("");
  const [emailValidationErrors, setEmailValidationErrors] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setNameErr("");
    setDomainErr("");
    setRedirectUrlErr("");
    setEmailValidationErrors("");

    try {
      setShowLoading(true);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/clients/add`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQGF1dGhmYXN0LmNvbSIsImlkIjo1LCJ1c2VyVHlwZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE2NjM2NTE2NzV9.raQf8JTVyiM51zg6OgH1RLkQqK_QyGPO2rJa9-oYDko",
        }),
        body: JSON.stringify({
          name,
          domain,
          redirect_url,
          email,
        }),
      });

      const responseData = await res.json();
      setShowLoading(false);

      if (res.status === 200 || res.status === 201) {
        navigate("/clients");
        return;
      }

      if (res.status === 400) {
        setErrorMessage(responseData?.message || "Something went wrong.");
        return;
      }

      if (res.status === 422 && Array.isArray(responseData?.errors)) {
        // server validation shape you described
        const getFirst = (prop) => {
          const err = responseData.errors.find((e) => e.property === prop);
          if (!err) return "";
          const vals = Object.values(err.constraints || {});
          return vals?.[0] || "";
        };
        setNameErr(getFirst("name"));
        setDomainErr(getFirst("domain"));
        setRedirectUrlErr(getFirst("redirect_url"));
        setEmailValidationErrors(getFirst("email"));
        return;
      }

      // fallback
      setErrorMessage(responseData?.message || "Failed to create client.");
    } catch (err) {
      console.error(err);
      setShowLoading(false);
      setErrorMessage("Network error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar: left back + centered title */}
      <div className="w-full bg-blue-600 text-white">
        <div className="max-w-5xl mx-auto px-4 py-3 relative flex items-center justify-center">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 inline-flex items-center gap-2 rounded-md bg-white/10 hover:bg-white/20 px-3 py-1.5 text-sm font-medium"
          >
            ← Back
          </button>
          <h1 className="text-lg md:text-xl font-semibold text-center">
            Create New Client
          </h1>
        </div>
      </div>

      {/* Content card */}
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="flex justify-center">
          <div className="w-full max-w-lg">
            <div className="rounded-2xl bg-white shadow-md ring-1 ring-black/5">
              <form onSubmit={handleSubmit} className="px-6 py-6">
                {/* Global error */}
                {errorMessage ? (
                  <div className="mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                    {errorMessage}
                  </div>
                ) : null}

                {/* Name */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter client name"
                    className={`w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
                      nameErr
                        ? "border-red-300 focus:ring-red-400"
                        : "border-gray-300 focus:ring-blue-500"
                    }`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {nameErr ? (
                    <p className="mt-1 text-xs text-red-600">{nameErr}</p>
                  ) : null}
                </div>

                {/* Domain */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Domain
                  </label>
                  <input
                    type="text"
                    placeholder="https://example.com"
                    className={`w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
                      domainErr
                        ? "border-red-300 focus:ring-red-400"
                        : "border-gray-300 focus:ring-blue-500"
                    }`}
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                  />
                  {domainErr ? (
                    <p className="mt-1 text-xs text-red-600">{domainErr}</p>
                  ) : (
                    <p className="mt-1 text-xs text-gray-500">
                      Root/app domain where SSO is allowed.
                    </p>
                  )}
                </div>

                {/* Redirect URL */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Redirect URL
                  </label>
                  <input
                    type="text"
                    placeholder="https://example.com/sso-signin"
                    className={`w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
                      redirect_urlErr
                        ? "border-red-300 focus:ring-red-400"
                        : "border-gray-300 focus:ring-blue-500"
                    }`}
                    value={redirect_url}
                    onChange={(e) => setRedirectUrl(e.target.value)}
                  />
                  {redirect_urlErr ? (
                    <p className="mt-1 text-xs text-red-600">
                      {redirect_urlErr}
                    </p>
                  ) : (
                    <p className="mt-1 text-xs text-gray-500">
                      Where the user should land after successful SSO.
                    </p>
                  )}
                </div>

                {/* Email */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="text"
                    placeholder="admin@example.com"
                    className={`w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${
                      emailValidationErrors
                        ? "border-red-300 focus:ring-red-400"
                        : "border-gray-300 focus:ring-blue-500"
                    }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailValidationErrors ? (
                    <p className="mt-1 text-xs text-red-600">
                      {emailValidationErrors}
                    </p>
                  ) : null}
                </div>

                {/* Actions */}
                <div className="mt-2 flex items-center justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    disabled={showLoading}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    disabled={showLoading}
                    className="inline-flex items-center rounded-md border border-blue-300 px-4 py-2 text-sm font-medium text-blue-700 hover:bg-blue-700"
                  >
                    {showLoading ? (
                      <span className="inline-flex items-center gap-2">
                        <svg
                          className="h-4 w-4 animate-spin"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                          />
                        </svg>
                        Creating…
                      </span>
                    ) : (
                      "Create Client"
                    )}
                  </button>
                </div>
              </form>
            </div>

            {/* Subtle help */}
            <p className="mt-4 text-xs text-gray-500 text-center">
              Make sure the domain and redirect URL are reachable in your
              environment.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsAdd;
